import type { Semester } from '@mathflat/domain/@entities/SchoolSystem/schema'
import { computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

type SchoolType = res.Student['schoolType']

type ConstructorParams = {
  schoolType: SchoolType
  grade: common.GradeSubject
  semester: Semester | null
  revision?: common.Revision
}
// 학년 타입, 학년 정보
export class SchoolSubjectGrade extends DTO {
  schoolType: SchoolType
  grade: common.GradeSubject
  semester: Semester | null = null
  revision?: common.Revision

  constructor({ schoolType, grade, semester, revision }: ConstructorParams) {
    super()
    this.schoolType = schoolType
    this.grade = grade
    this.semester = semester
    this.revision = revision

    makeObservable(this, {
      schoolType: observable,
      grade: observable,
      semester: observable,
      koSchoolGrade: computed,
      gradeSemesterLabel: computed,
      gradeSemesterRevisionLabel: computed,
    })
  }

  private static _formatHighGrade(grade: common.Subject_High) {
    switch (grade) {
      case '고등수학(상)':
        return '수학(상)'
      case '고등수학(하)':
        return '수학(하)'
      case '확률과 통계':
        return '확통'
      default:
        return grade
    }
  }

  get gradeSemesterRevisionLabel() {
    const gradeSemester =
      this.schoolType === 'HIGH'
        ? SchoolSubjectGrade._formatHighGrade(this.grade as common.Subject_High)
        : `${this.koSchoolGrade}-${this.semester}`

    return this.revision === 'CURRICULUM_22' ? `${gradeSemester}(22개정)` : gradeSemester
  }

  get gradeSemesterLabel() {
    return this.schoolType === 'HIGH'
      ? SchoolSubjectGrade._formatHighGrade(this.grade as common.Subject_High)
      : `${this.koSchoolGrade}-${this.semester}`
  }

  get koSchoolGrade() {
    switch (this.schoolType) {
      case 'ELEMENTARY': {
        switch (this.grade) {
          case '1':
            return '초1'
          case '2':
            return '초2'
          case '3':
            return '초3'
          case '4':
            return '초4'
          case '5':
            return '초5'
          case '6':
          default:
            return '초6'
        }
      }
      case 'MIDDLE': {
        switch (this.grade) {
          case '1':
            return '중1'
          case '2':
            return '중2'
          case '3':
          default:
            return '중3'
        }
      }
      default:
        return this.grade as common.Subject_High
    }
  }
}
